import { createSlice } from "@reduxjs/toolkit";
import {
  getTeacherBaselineThunk,
  createTeacherBaselineThunk,
  updateTeacherBaselineThunk,
  deleteTeacherBaselineThunk,
} from "./TeacherCategory.Thunk";

const initialState = {
  data: [],
  category: [],
  loading: false,
  status: "",
  message: "",
  type: "",
  preferedlanguage: "",
  categoryid: "",
  categoryname: "",
  usertype: "",
  disable_content_button: true,
};

const TeacherCategorySlice = createSlice({
  name: "teachercategoryslice",
  initialState,
  reducers: {
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.categoryid = "";
      state.categoryname = "";
      state.disable_content_button = true;
    },
  },
  extraReducers: {
    [getTeacherBaselineThunk.pending]: (state, action) => {
      state.category = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineThunk.fulfilled]: (state, action) => {
      state.category = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineThunk.rejected]: (state, action) => {
      state.category = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [createTeacherBaselineThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createTeacherBaselineThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createTeacherBaselineThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateTeacherBaselineThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateTeacherBaselineThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateTeacherBaselineThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { usertype_change } = TeacherCategorySlice.actions;

export default TeacherCategorySlice.reducer;
